import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 17a2 2 0 0 0 2 2h5.611a1 1 0 1 0 0-2H4V6h15v3.643a1 1 0 0 0 2 0V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2z"
    }
  )
);
var SvgPictureInPictureOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PictureInPictureOutlined_default = SvgPictureInPictureOutlined;

export { PictureInPictureOutlined_default as default };
